/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
    GET_USER_TOKENS = '[Tokens] Get User Tokens',
    GET_USER_TOKENS_SUCCESS = '[Tokens] Get User Tokens Success',
    RELOAD_USER_TOKEN = '[Tokens] Reload User Tokens Success',
    SET_USER_TOKEN_LOADER = '[Tokens] Set User Token Loader',
    GET_TOKENS_FOR_SALE = '[Tokens] Get Tokens For Sale',
    GET_TOKENS_FOR_SALE_SUCCESS = '[Tokens] Get Tokens For Sale Success',
    CHECK_TOKEN_ORDER_STATUS = '[Tokens] Get Token Order Status',
    CHECK_TOKEN_ORDER_STATUS_SUCCESS = '[Tokens] Get Token Order Status Success',
    GET_TOKENS_ORDER_HISTORY = '[Tokens] Get Tokens Order History',
    GET_TOKENS_ORDER_HISTORY_SUCCESS = '[Tokens] Get Tokens Order History Success',

    /** TOKEN STORE */
    GET_TOKEN_CART = '[Tokens] Get Token Cart',
    UPDATE_TOKEN_CART = '[Tokens] Update Token Cart',
    UPDATE_TOKEN_CART_SUCCESS = '[Tokens] Update Token Cart Success',
    CLEAR_TOKEN_CART = '[Tokens] Clear Token Cart'
}

export const getUserTokens = createAction(
    ActionTypes.GET_USER_TOKENS,
    props<{ data: any }>()
);
export const getUserTokensSuccess = createAction(
    ActionTypes.GET_USER_TOKENS_SUCCESS,
    props<{ data: any }>()
);

export const reloadUserTokens = createAction(
    ActionTypes.RELOAD_USER_TOKEN
);

export const setUserTokerLoader = createAction(
    ActionTypes.SET_USER_TOKEN_LOADER,
    props<{ status: boolean }>()
);

export const getTokensForSale = createAction(
    ActionTypes.GET_TOKENS_FOR_SALE,
    props<{ data: any }>()
);
export const getTokensForSaleSuccess = createAction(
    ActionTypes.GET_TOKENS_FOR_SALE_SUCCESS,
    props<{ data: any }>()
);

export const checkTokenOrderStatus = createAction(
    ActionTypes.CHECK_TOKEN_ORDER_STATUS
);
export const checkTokenOrderStatusSuccess = createAction(
    ActionTypes.CHECK_TOKEN_ORDER_STATUS_SUCCESS
);

export const getTokensOrderHistory = createAction(
    ActionTypes.GET_TOKENS_ORDER_HISTORY,
    props<{ data: any }>()
);
export const getTokensOrderHistorySuccess = createAction(
    ActionTypes.GET_TOKENS_ORDER_HISTORY_SUCCESS,
    props<{ data: any }>()
);

/** TOKEN STORE */
export const getTokenCart = createAction(
    ActionTypes.GET_TOKEN_CART,
    props<{ data: any }>()
);

export const updateTokenCart = createAction(
    ActionTypes.UPDATE_TOKEN_CART,
    props<{ data: any }>()
);

export const updateTokenCartSuccess = createAction(
    ActionTypes.UPDATE_TOKEN_CART_SUCCESS,
    props<{ data: any }>()
);

export const clearTokenCart = createAction(
    ActionTypes.CLEAR_TOKEN_CART
);


